<template>
  <div class="main">
    <img class="bg-img" src="./images/bg.jpg" alt="" />
    <div class="action-box">
      <button class="btn-countdown" @click="publish()">
        {{ status === 1 ? '重新投稿' : '我要投稿' }}
      </button>
    </div>
    <publish-dialog
      ref="publishDialog"
      :uuid="uuid"
      :votesType="votesType"
      @success="refresh()"
    ></publish-dialog>
  </div>
</template>
<script>
import publishDialog from './publish-dialog.vue';
export default {
  components: { publishDialog },
  name: 'SubmissionStage',
  data() {
    return {};
  },
  props: {
    status: {
      type: Number
    },
    uuid: {
      type: String
    },
    votesType: {
      type: String
    },
    endDate: {
      type: [Number, String]
    }
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    },
    publish() {
      if (new Date().getTime() >= this.endDate) {
        this.$confirm({
          content: '投稿已截止',
          confirmButtonText: '確定',
          className: 'custom-draw-dialog',
          showCancelButton: false,
          closeOnClickModal: false
        }).then(() => {
          this.refresh();
        });
        return;
      }
      this.$refs.publishDialog.show();
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 750px;
  flex: none;
  > .bg-img {
    width: 100%;
    max-width: 100%;
    margin-bottom: 206px;
    flex: none;
  }
  .action-box {
    flex: none;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 256px;
    background: linear-gradient(180deg, rgba(3, 0, 46, 0) 0%, #03002e 22.62%);
    display: flex;
    align-items: center;
    justify-content: center;
    .btn-countdown {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 614px;
      height: 88px;
      background: #ffcb46;
      border-radius: 40px;
      font-weight: 600;
      font-size: 32px;
      line-height: 44px;
      color: #2e2e2e;
    }
  }
}
</style>
